(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/registrate/player-registrate.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/registrate/player-registrate.js');

'use strict';

const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const _svs$playerLoginReact = svs.playerLoginReact.constants,
  loginType = _svs$playerLoginReact.loginType,
  route = _svs$playerLoginReact.route;

const PlayerRegistrate = _ref => {
  let isBankId = _ref.isBankId,
    _ref$isHome = _ref.isHome,
    isHome = _ref$isHome === void 0 ? false : _ref$isHome;
  const history = useHistory();
  const lastPlayerLoginType = ReactRedux.useSelector(state => state.playerloginreact.lastPlayerLoginType);
  if (isHome && lastPlayerLoginType === loginType.BANKID || !isHome && isBankId) {
    history.push(route.REGISTRATE_BANKID_START_ROUTE);
  } else {
    history.push(route.REGISTRATE_FREJAEID_POLL_ROUTE);
  }
  return null;
};
PlayerRegistrate.propTypes = {
  isBankId: PropTypes.bool.isRequired,
  isHome: PropTypes.bool
};
svs.playerLoginReact.registrate.PlayerRegistrate = PlayerRegistrate;

 })(window);